<template>
  <div class="menuBg">
    <confirm
      v-if="showCancelConfirmDialog"
      :title="$t('combo.dialog.cancel.title')"
      :header="$t('combo.dialog.cancel.header')"
      :button_text_approve="$t('dialog.confirm.btn_combo.approve')"
      :button_text_deny="$t('dialog.confirm.btn_combo.deny')"
      @onConfirm="cancelCombo"
      @onClose="showCancelConfirmDialog = false"
    ></confirm>
    <div class="main-menu" v-if="currentComponent">
      <div>
        <header-menu-select
          :activeCombo="this.activeCombo"
          v-if="this.activeCombo.selectedCombo"
        />
        <header-menu :activeCombo="this.activeCombo" v-else />
        <header-nav
          v-if="activeCombo.selectedCombo"
          :activeCombo="this.activeCombo"
          :currentComponent="this.currentComponent"
          :noprices="project === 'elite'"
          @changeComponent="changeComponentRequested"
        />
        <select-combo
          :component="currentComponent"
          :currentComponent="this.currentComponent"
          @changeComponent="changeComponentRequested"
          v-if="this.activeCombo.selectedCombo"
        />
        <request-combo v-else @changeComponent="changeComponentRequested" />
      </div>
      <div class="cancelComboBlock">
        <div class="cancelBtn" @click="showCancelConfirmDialog = true">
          {{ $t("combo.btn.cancel") }}
        </div>
      </div>
      <div>
        <bottom-nav
          :show-total-container="true"
          :show-scan-and-go="false"
          :show-submit="true"
          disableProceed
          :noprices="project === 'elite'"
          >{{ $t("menu.footer.complete_order") }}</bottom-nav
        >
      </div>
    </div>
  </div>
</template>
<script>
import BottomNav from "@/components/BottomNav.vue";
import HeaderMenu from "@/components/combo/HeaderCombo.vue";
import HeaderMenuSelect from "@/components/combo/HeaderSelectCombo.vue";
import RequestCombo from "@/components/combo/RequestCombo.vue";
import SelectCombo from "@/components/combo/SelectCombo.vue";
import HeaderNav from "@/components/combo/HeaderNav.vue";

import { mapActions, mapGetters } from "vuex";
import { opacityAnimation } from "@/utils/helpers";
import Confirm from "../components/modals/confirm";

export default {
  components: {
    Confirm,
    BottomNav,
    HeaderMenu,
    HeaderMenuSelect,
    RequestCombo,
    SelectCombo,
    HeaderNav
  },
  data() {
    return {
      currentComponent: null,
      showCancelConfirmDialog: false
    };
  },
  computed: {
    ...mapGetters({
      basket: "BASKET",
      activeCombo: "ACTIVE_COMBO",
      project: "PROJECT"
    })
  },
  mounted() {
    const data = {
      from: 0,
      to: 1,
      step: 0.05
    };
    opacityAnimation("requestImgBlock", data);
  },
  created() {
    if (!this.activeCombo || !this.activeCombo.id) {
      this.logRouter({ name: "menu", router: this.$router });
    }
    if (this.activeCombo && this.activeCombo.components) {
      this.currentComponent = this.activeCombo.components.find(
        item => !item.selected
      );
    }
  },
  methods: {
    cancelCombo() {
      this.logRouter({ name: "menu", router: this.$router });
    },
    changeComponentRequested(payload) {
      if (this.activeCombo && this.activeCombo.components) {
        const result = this.activeCombo.components.find(
          item => item.id === payload.id
        );
        if (result) {
          this.currentComponent = result;
        }
      }
    },
    ...mapActions({
      logRouter: "LOG_ROUTER"
    })
  }
};
</script>
<style lang="scss" scoped>
.menuBg {
  background: transparent
    linear-gradient(0deg, #fcf8f5 0%, #fcf8f5 75%, #e8d4c5 100%) 0% 0% no-repeat
    padding-box;
}
.filler {
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tabs-wrapper {
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  z-index: 5;
}

.cancelComboBlock {
  position: absolute;
  bottom: 194px;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 0 60px;
  width: 100%;
}
.cancelBtn {
  color: var(--page_Combo_cancelBtn_color);
  border: var(--page_Combo_cancelBtn_border);
  background: var(--page_Combo_cancelBtn_background);
  width: 210px;
  height: 70px;
  border-radius: var(--page_Combo_cancelBtn_border-radius);
  letter-spacing: var(--app_letter-spacing_dense);
  font-family: var(--page_Combo_cancelBtn_font-family);
  font-size: var(--page_Combo_cancelBtn_font-size);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
